import { Outlet } from "react-router-dom";

export default function ExperiencesParentPage() {

    return (
        <Outlet />
    );
}